import React from 'react';
import { IContextMenuOption } from './interfaces';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

export const ContextMenuOption: React.FC<IContextMenuOption> = ({
  label,
  icon: Icon,
  onClick,
}): JSX.Element => {
  return (
    <MenuItem onClick={onClick}>
      {Icon && (
        <ListItemIcon>
          <Icon fontSize="small" />
        </ListItemIcon>
      )}
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  );
};
